import React, { useEffect, useState, useMemo } from "react";

import {
  OnePagePortfolioAssessmentAnswer,
  OnePagePortfolioAssessment,
} from "../../../state";
import Modal from "../../../atoms/Modal";
import Button from "../../../atoms/ActiveLearning/Button";
import img from "../../../assets/images/oppa-before-modal_img.webp";
import { ReactComponent as CloseIcon } from "../../../assets/svg/oppa-before-modal_close.svg";

import styles from "./BeforeModal.module.scss";

export type BeforeModalProps = {
  isTeacher?: boolean;
  assessmentId: number;
  assessmentData: OnePagePortfolioAssessment | null;
  calling?: boolean;
  fetchOnePagePortfolioAssessment?: (id: number) => void;
  registerOnePagePortfolioAssessmentAnswers?: (
    id: number,
    answers: OnePagePortfolioAssessmentAnswer[],
  ) => void;
  onClose: () => void;
};

const BeforeModal: React.FC<BeforeModalProps> = ({
  isTeacher,
  assessmentId,
  assessmentData,
  calling,
  fetchOnePagePortfolioAssessment,
  registerOnePagePortfolioAssessmentAnswers,
  onClose,
}) => {
  const [answer, setAnswer] = useState<string>("");

  useEffect(() => {
    if (!fetchOnePagePortfolioAssessment) return;

    fetchOnePagePortfolioAssessment(assessmentId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessmentId]);

  const assessmentTitle = useMemo(() => {
    const title = assessmentData?.title ?? "";
    return title.replace(/\s*-高校-|\s*-中学-/g, "");
  }, [assessmentData]);

  const question = useMemo(() => {
    const issue = assessmentData?.one_page_portfolio_assessment_issues?.[0];
    const question = issue?.one_page_portfolio_assessment_questions?.[0];

    return {
      id: question?.id ?? 0,
      title: question?.title ?? "",
      answer: question?.one_page_portfolio_assessment_answer?.contents ?? "",
    };
  }, [assessmentData]);

  useEffect(() => {
    setAnswer(question.answer);
  }, [question.answer]);

  const handleSubmit = () => {
    if (!registerOnePagePortfolioAssessmentAnswers) return;

    const assessmentAnswer: OnePagePortfolioAssessmentAnswer[] = [
      {
        one_page_portfolio_assessment_question_id: question.id,
        contents: answer,
      },
    ];
    registerOnePagePortfolioAssessmentAnswers(assessmentId, assessmentAnswer);
  };

  return (
    <Modal onClose={onClose} className={styles.beforeModal}>
      <CloseIcon className={styles.closeIcon} onClick={onClose} />
      <div className={styles.wrapper}>
        <img className={styles.img} src={img} alt="" aria-hidden="true" />
        <p className={styles.title}>{assessmentTitle}</p>
        <p className={styles.questionTitle}>{question.title}</p>
        <textarea
          className={styles.textarea}
          value={answer}
          placeholder={"テキストを入力してください。"}
          onChange={e => setAnswer(e.target.value)}
          disabled={isTeacher}
        />
        {!isTeacher && (
          <Button handleClick={handleSubmit} disabled={calling}>
            回答を送信する
          </Button>
        )}
      </div>
    </Modal>
  );
};

export default BeforeModal;
